import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIssueOther = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		d: "M6.989 12.024a1.494 1.494 0 1 1-2.989 0 1.494 1.494 0 0 1 2.989 0zm6.506 0a1.494 1.494 0 1 1-2.99 0 1.494 1.494 0 0 1 2.99 0zm5.011 1.494a1.494 1.494 0 1 0 0-2.989 1.494 1.494 0 0 0 0 2.99z"
	})
});
export default SvgIssueOther;
